(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-navigation"] && !Shopify.designMode) return;
  try {
    class CartNavigation extends HTMLElement {
    constructor() {
      super();
      this.favoriteLink = this.querySelector('.js-nav-favorite');
      this.cartLink = this.querySelector('.js-nav-cart');
      this.favoriteCount = this.querySelector('.js-favorites-count');
      this.init();
      this.countFavorites();
    }

    init() {
      this.favoriteLink?.addEventListener('click', (e) => {
        e.preventDefault();
        window.dispatchEvent(new CustomEvent('drawer:switch', { detail: 'favorite' }));
      });

      this.cartLink?.addEventListener('click', (e) => {
        e.preventDefault();
        window.dispatchEvent(new CustomEvent('drawer:switch', { detail: 'cart' }));
      });
    }
    countFavorites() {
      window.addEventListener('swym:lists:fetched', (e) => {
        const lists = e.detail.lists;
        const favoriteList = lists[0];

        if (favoriteList) {
          this.favoriteCount.textContent = favoriteList.listcontents.length;
        } else {
          this.favoriteCount.textContent = '0';
        }
      });
    }
  }

  customElements.define('cart-navigation', CartNavigation);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cross-sell-card"] && !Shopify.designMode) return;
  try {
    class CrossSellCard extends HTMLElement {
    constructor() {
      super();
      this.atc = this.querySelector('.js-cross-atc');
      this.sizeSelector = this.querySelector('[data-size-selector]');
      this.options = this.sizeSelector ? Array.from(this.sizeSelector.querySelectorAll('.js-cross-size-opt')) : [];
      if (this.atc) {
        this.atc.addEventListener('click', this.showSizeOptions.bind(this));
      }
      this.options = this.options.map((option) => {
        option.addEventListener('click', (event) => {
          const variantId = event.target.getAttribute('data-variant-id');
          if (variantId) {
            window.addItemsToCart
              ? window.addItemsToCart([{ variantId: variantId, qty: 1 }])
              : console.error('addItemsToCart function is not defined.');
          } else {
            console.error('Variant ID not found for the selected size option.');
          }
        });
        return option;
      });
    }

    showSizeOptions() {
      if (this.options.length > 0) {
        this.sizeSelector.classList.remove('hidden');
      } else {
        console.error('No size options available for this product.');
      }
    }
  }
  customElements.define('cross-sell-card', CrossSellCard);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["custom-select"] && !Shopify.designMode) return;
  try {
    class CustomSelect extends HTMLElement {
    constructor() {
      super();

      this.nativeSelect = this.querySelector('select');
      this.trigger = this.querySelector('[data-trigger]');
      this.valueDisplay = this.querySelector('[data-value]');
      this.dropdown = this.querySelector('[data-dropdown]');
      this.arrow = this.querySelector('[data-arrow]');

      this.init();
    }

    init() {
      if (!this.nativeSelect || !this.trigger || !this.dropdown) return;

      // Parse options from the native select
      this.options = Array.from(this.nativeSelect.querySelectorAll('option')).map((opt) => ({
        value: opt.value,
        label: opt.textContent.trim(),
        selected: opt.selected,
        attributes: {
          lang: opt.getAttribute('lang'),
        },
      }));

      this.populateDropdown();
      this.attachEventListeners();
    }

    populateDropdown() {
      // Get font styles from trigger button
      const triggerStyles = window.getComputedStyle(this.trigger);
      const fontSize = triggerStyles.fontSize;
      const fontFamily = triggerStyles.fontFamily;
      const fontStyle = `font-size: ${fontSize}; font-family: ${fontFamily};`;

      this.dropdown.innerHTML = this.options
        .map(
          (option, index) => `
        <li
          class="custom-select__option"
          role="option"
          aria-selected="${option.selected}"
          data-value="${option.value}"
          data-index="${index}"
          style="${fontStyle}"
          ${option.attributes.lang ? `lang="${option.attributes.lang}"` : ''}
        >
          ${option.label}
        </li>
      `
        )
        .join('');

      // Set initial value
      const selectedOption = this.options.find((opt) => opt.selected);
      if (selectedOption) {
        this.valueDisplay.textContent = selectedOption.label;
      }
    }

    toggleDropdown() {
      const isExpanded = this.trigger.getAttribute('aria-expanded') === 'true';
      this.trigger.setAttribute('aria-expanded', !isExpanded);
      this.dropdown.classList.toggle('hidden');
    }

    closeDropdown() {
      this.trigger.setAttribute('aria-expanded', 'false');
      this.dropdown.classList.add('hidden');
    }

    selectOption(value, label) {
      // Update native select
      this.nativeSelect.value = value;

      // Update display
      this.valueDisplay.textContent = label;

      // Update aria-selected
      this.dropdown.querySelectorAll('[role="option"]').forEach((opt) => {
        opt.setAttribute('aria-selected', opt.dataset.value === value);
      });

      // Trigger change event
      this.nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));

      this.closeDropdown();
    }

    attachEventListeners() {
      // Toggle on button click
      this.trigger.addEventListener('click', () => this.toggleDropdown());

      // Select option on click
      this.dropdown.addEventListener('click', (e) => {
        const option = e.target.closest('[role="option"]');
        if (option) {
          this.selectOption(option.dataset.value, option.textContent.trim());
        }
      });

      // Close on outside click
      document.addEventListener('click', (e) => {
        if (!this.contains(e.target)) {
          this.closeDropdown();
        }
      });

      // Close on Escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.closeDropdown();
        }
      });
    }
  }

  customElements.define('custom-select', CustomSelect);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["newsletter_form"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    const FETCH_TIMEOUT = 10000;

    class SignupForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.submitBtnContainer = this.form.querySelector('.submit-button');
        this.submitInput = this.form.querySelector('[type="submit"]');
        this.emailInput = this.form.querySelector('input[type="email"]');
        this.successEl = this.form.querySelector('.successful-msg');
        this.successMsg = this.successEl ? this.successEl.innerHTML : 'EMAIL SAVED';
        this.errorEl = this.querySelector('.js-error-message');

        this.addReturnToParameter();

        // Input validation + autofill handling
        if (this.emailInput) {
          this.emailInput.addEventListener('input', (e) => {
            this.hideError();
            this.validateEmail(e.target.value);
          });
          this.emailInput.addEventListener('change', (e) => {
            this.hideError();
            this.validateEmail(e.target.value);
          });
          setTimeout(() => {
            if (this.emailInput.value) this.validateEmail(this.emailInput.value);
          }, 100);
        }

        // Attach captcha-aware submit handling
        this.bindCaptchaAwareSubmit();
      }

      validateEmail(value) {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const enabled = emailPattern.test(value);
        if (this.submitBtnContainer) {
          this.submitBtnContainer.classList.toggle('font-bold', enabled);
          this.submitBtnContainer.classList.toggle('border-b', enabled);
        }
        return enabled;
      }

      showError() {
        if (this.errorEl) {
          this.errorEl.classList.remove('hidden');
        }
      }

      hideError() {
        if (this.errorEl) {
          this.errorEl.classList.add('hidden');
        }
      }

      isEmailValid() {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailPattern.test(this.emailInput ? this.emailInput.value : '');
      }

      addReturnToParameter() {
        const isInPopup = this.closest('newsletter-popup') !== null;
        const source = isInPopup ? 'popup' : 'footer';
        const returnToInput = document.createElement('input');
        returnToInput.type = 'hidden';
        returnToInput.name = 'return_to';
        const currentUrl = new URL(window.location.href);
        returnToInput.value = currentUrl.pathname + '?source=' + source;
        this.form.appendChild(returnToInput);
      }

      bindCaptchaAwareSubmit() {
        if (!this.form) return;
        if (this.form.dataset.ajaxBound) return;
        this.form.dataset.ajaxBound = 'true';

        let isProcessingAjax = false;
        const originalAction = this.form.action;

        const nativeSubmit = this.form.submit.bind(this.form);
        this.form.submit = () => {
          if (!isProcessingAjax) {
            isProcessingAjax = true;
            this.handleSubmit().finally(() => {
              isProcessingAjax = false;
            });
          }
        };

        this.form.addEventListener(
          'submit',
          (e) => {
            // Check email validity first
            if (!this.isEmailValid()) {
              e.preventDefault();
              e.stopImmediatePropagation();
              this.showError();
              return;
            }

            this.hideError();

            const hCaptchaInput = this.form.querySelector('[name="h-captcha-response"]');

            if (hCaptchaInput && hCaptchaInput.value) {
              e.preventDefault();
              e.stopImmediatePropagation();
              if (!isProcessingAjax) {
                isProcessingAjax = true;
                this.handleSubmit().finally(() => {
                  isProcessingAjax = false;
                });
              }
              return;
            }

            if (hCaptchaInput && !hCaptchaInput.value) {
              this.form.action = 'about:blank';
              setTimeout(() => {
                this.form.action = originalAction;
              }, 100);
              return; // allow Shopify's handler to run
            }

            // No captcha present — handle via AJAX
            e.preventDefault();
            e.stopImmediatePropagation();
            if (!isProcessingAjax) {
              isProcessingAjax = true;
              this.handleSubmit().finally(() => {
                isProcessingAjax = false;
              });
            }
          },
          true
        );
      }

      async handleSubmit() {
        const submitContainer = this.submitBtnContainer;
        const submitBtn = this.submitInput;

        if (submitContainer) {
          submitContainer.classList.add('pointer-events-none', 'opacity-50');
        }
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.setAttribute('aria-busy', 'true');
        }

        try {
          const body = new FormData(this.form);

          // optional debug
          // for (let [k,v] of body.entries()) console.log(k, v);

          const controller = new AbortController();
          const timer = setTimeout(() => controller.abort(), FETCH_TIMEOUT);

          const response = await fetch(this.form.action, {
            method: 'POST',
            body,
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
            },
            credentials: 'same-origin',
            signal: controller.signal,
          });

          clearTimeout(timer);

          const finalUrl = response.url || '';
          if (finalUrl.includes('challenge')) {
            // hCaptcha challenge failed — redirect user to solve it
            window.location.href = finalUrl;
            return;
          }

          if (response.ok) {
            this.hideError();
            if (this.successEl) this.successEl.classList.remove('hidden');

            if (this.successEl) this.successEl.innerHTML = this.successMsg;
            this.form.reset();
            localStorage.setItem('newsletter_subscribed', 'true');
            window.dispatchEvent(new CustomEvent('newsletter:subscribed'));
          } else {
            console.error('Newsletter submission failed', response.status);
            if (this.successEl) this.successEl.classList.remove('hidden');
          }
        } catch (err) {
          if (err.name === 'AbortError') {
            console.error('Newsletter request timed out');
          } else {
            console.error('Error submitting newsletter form', err);
          }
        } finally {
          if (submitContainer) {
            submitContainer.classList.remove('pointer-events-none', 'opacity-50');
          }
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.removeAttribute('aria-busy');
          }
        }
      }
    }

    customElements.define('signup-form', SignupForm);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    class CardProduct extends HTMLElement {
    constructor() {
      super();
      this.link = this.querySelector('a');
      this.isDragging = false;
      this.startX = 0;
      this.startY = 0;
      this.dragThreshold = 5; // pixels of movement to consider it a drag

      if (this.link) {
        this.link.addEventListener('mousedown', this.handleStart.bind(this));
        this.link.addEventListener('touchstart', this.handleStart.bind(this), { passive: true });
        this.link.addEventListener('mousemove', this.handleMove.bind(this));
        this.link.addEventListener('touchmove', this.handleMove.bind(this), { passive: true });
        this.link.addEventListener('click', this.handleClick.bind(this));
      }
    }

    handleStart(e) {
      this.isDragging = false;
      const point = e.touches ? e.touches[0] : e;
      this.startX = point.clientX;
      this.startY = point.clientY;
    }

    handleMove(e) {
      const point = e.touches ? e.touches[0] : e;
      const deltaX = Math.abs(point.clientX - this.startX);
      const deltaY = Math.abs(point.clientY - this.startY);

      if (deltaX > this.dragThreshold || deltaY > this.dragThreshold) {
        this.isDragging = true;
      }
    }

    handleClick(e) {
      if (this.isDragging) {
        e.preventDefault();
      }
    }
  }
  customElements.define('card-product', CardProduct);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.options = Array.from(this.querySelectorAll('.js-option-btn'));
      this.init();
    }

    init() {
      // Set initial selected state based on current variant
      if (window.location.href.includes('?variant=')) {
        this.setInitialSelection();
      }

      // Add event listeners
      this.options.forEach((option) => {
        option.addEventListener('click', (event) => {
          this.selectOption(event.currentTarget);
        });
      });
    }

    setInitialSelection() {
      // Auto-select first option for each group or selected variant options
      const optionGroups = {};

      this.options.forEach((option) => {
        const input = option.querySelector('input[type="radio"]');
        const optionName = input.name;

        if (!optionGroups[optionName]) {
          optionGroups[optionName] = [];
        }
        optionGroups[optionName].push(option);

        // Check if this option should be selected
        if (input.checked) {
          this.markAsSelected(option);
        }
      });

      // Auto-select first option if none selected
      Object.keys(optionGroups).forEach((groupName) => {
        const group = optionGroups[groupName];
        const hasSelected = group.some((opt) => opt.querySelector('input').checked);

        if (!hasSelected && group.length > 0) {
          const firstInput = group[0].querySelector('input');
          firstInput.checked = true;
          this.markAsSelected(group[0]);
        }
      });
    }

    selectOption(optionElement) {
      const input = optionElement.querySelector('input[type="radio"]');
      const optionName = input.name;

      // Unselect all options in the same group
      this.options.forEach((option) => {
        const optionInput = option.querySelector('input[type="radio"]');
        if (optionInput.name === optionName) {
          this.markAsUnselected(option);
          optionInput.checked = false;
        }
      });

      // Select clicked option
      input.checked = true;
      this.markAsSelected(optionElement);

      // Trigger variant update
      const productMain = this.closest('product-main');
      if (productMain) {
        productMain.updateVariantFromOptions();
      }
    }

    markAsSelected(optionElement) {
      optionElement.classList.add('selected');
      optionElement.style.fontWeight = '600';
    }

    markAsUnselected(optionElement) {
      optionElement.classList.remove('selected');
      optionElement.style.fontWeight = '400';
    }
  }
  customElements.define('variant-picker', VariantPicker);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["video"] && !Shopify.designMode) return;
  try {
    class VideoOptimizer {
    constructor() {
      this.videos = new Map();
      this.observerOptions = {
        root: null,
        rootMargin: '50px',
        threshold: 0.1,
      };
      this.init();
    }

    init() {
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(this.handleIntersection.bind(this), this.observerOptions);
        this.observeVideos();
      } else {
        // Fallback for older browsers
        this.loadAllVideos();
      }

      this.attachPlayButtonListeners();
    }

    observeVideos() {
      const videoWrappers = document.querySelectorAll('.video-wrapper[data-video-lazy="true"]');
      videoWrappers.forEach((wrapper) => {
        this.observer.observe(wrapper);
      });
    }

    handleIntersection(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const wrapper = entry.target;
          const shouldAutoplay = wrapper.dataset.videoAutoplay === 'true';
          const videos = wrapper.querySelectorAll('.video-element');

          if (videos && shouldAutoplay) {
            // Preload video when near viewport
            videos.forEach((video) => {
              if (video.preload === 'none') {
                video.preload = 'metadata';
              }
            });

            // Only autoplay if actually in viewport and user hasn't interacted
            if (entry.intersectionRatio > 0.5) {
              videos.forEach((video) => {
                this.playVideo(video);
              });
            }
          }

          // Stop observing once loaded
          this.observer.unobserve(wrapper);
        }
      });
    }

    playVideo(video) {
      if (!video || video.dataset.played === 'true') return;

      const playPromise = video.play();

      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            video.dataset.played = 'true';
          })
          .catch((error) => {
            // Autoplay was prevented - this is normal on some browsers
            console.log('Video autoplay prevented:', error);
          });
      }
    }

    attachPlayButtonListeners() {
      const buttons = document.querySelectorAll('.video-preview-button');

      buttons.forEach((button) => {
        button.addEventListener(
          'click',
          (e) => {
            e.preventDefault();
            const videoType = button.dataset.videoType;

            if (videoType === 'external') {
              this.loadExternalVideo(button);
            } else if (videoType === 'shopify') {
              this.loadShopifyVideo(button);
            }
          },
          { once: true }
        );
      });
    }

    loadExternalVideo(button) {
      const videoSrc = button.dataset.videoSrc;
      const wrapper = button.closest('.video-wrapper');

      // Create iframe with facade pattern
      const iframe = document.createElement('iframe');
      iframe.src = videoSrc;
      iframe.className = 'w-full h-full';
      iframe.allow = 'autoplay; encrypted-media';
      iframe.allowFullscreen = true;
      iframe.title = button.querySelector('img')?.alt || 'Video';
      iframe.loading = 'lazy';

      // Hide button and show iframe
      button.style.display = 'none';
      wrapper.appendChild(iframe);

      // Clean up
      requestAnimationFrame(() => {
        button.remove();
      });
    }

    loadShopifyVideo(button) {
      const video = button.nextElementSibling;

      if (!video || video.tagName !== 'VIDEO') return;

      // Hide button
      button.style.display = 'none';

      // Show and play video
      video.style.display = 'block';
      video.preload = 'auto';

      // Use requestIdleCallback for better performance
      if ('requestIdleCallback' in window) {
        requestIdleCallback(() => {
          this.playVideo(video);
        });
      } else {
        setTimeout(() => {
          this.playVideo(video);
        }, 100);
      }
    }

    loadAllVideos() {
      // Fallback: load all videos immediately
      const buttons = document.querySelectorAll('.video-preview-button');
      buttons.forEach((button) => button.click());
    }
  }

  // Initialize on DOM ready with better performance
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new VideoOptimizer();
    });
  } else {
    new VideoOptimizer();
  }

  // Reinitialize for dynamically added content (e.g., AJAX cart, quick view)
  document.addEventListener('shopify:section:load', () => {
    new VideoOptimizer();
  });
  } catch(e) { console.error(e); }
})();

})();
